import { Component, Input, OnDestroy, OnInit, AfterViewInit, ViewChildren, QueryList } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';

import { DynReportService, ReportPeriod, Report10, ReportFilter, GroupCode } from '../shared';

import {
  CanComponentDeactivate,
  EntityService,
  ModalService,
  ToastService,
  MessageService
} from '../../core';
import { Message, TreeNode, SelectItem } from "primeng/primeng";

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'bp-dyn-report',
  templateUrl: './dyn-report10.component.html',
  styleUrls: ['./dyn-report10.component.css'],
})

export class DynReport10Component implements OnDestroy, OnInit, AfterViewInit {

  private dbResetSubscription: Subscription;
  private id: any;

  @ViewChildren('scroll') scroll: QueryList<any>;

  filter: ReportFilter;
  selectedRow: TreeNode;
  infos: Message[];
  report: Report10;

  selectedPeriod: ReportPeriod;
  groups: GroupCode[];

  selectedYear: SelectItem;
  selectedGroup: GroupCode = { value: "", text: "-" };

  budgetExeGraphData: any;
  budgetStructGraphData: any;
  top5expendituresGraphData: any;

  constructor(
    private entityService: EntityService,
    private modalService: ModalService,
    private route: ActivatedRoute,
    private router: Router,
    private reportService: DynReportService,
    private toastService: ToastService) {

  }

  private getYears() {
    this.reportService.getReport10Years()
      .subscribe(filter => {
        this.filter = filter;
      });
  }


  private getPeriods() {
    this.reportService.getReport10Periods(this.selectedYear.value)
      .subscribe(filter => {
        if (this.filter) {
          this.filter.periods = filter.periods;
        } else {
          this.filter = filter;
        }
      });
  }

  private getReport(id: number, selectedGroup: string) {

    this.reportService.getReport10(id, selectedGroup)
      .subscribe(report => {
        this.report = report;

        //this.report.ttData = this.reportService.buildTableData10(this.report.data);
        this.budgetExeGraphData = this.reportService.buildBudgetExeGraphData10(this.report.graphData);
        this.budgetStructGraphData = this.reportService.buildBudgetStructGraphData10(this.report.graphData);
        this.top5expendituresGraphData = this.reportService.buildTop5expendituresGraphData10(this.report.topExpenditures);
      });
  }



  private gotoReports() {
    this.router.navigate(['/reports']);
  }

  private handleServiceError(op: string, err: any) {
    console.error(`${op} error: ${err.message || err}`);
  }

  ngOnInit() {
    //this.route
    //  .params
    //  .map(params => params['id'])
    //  .do(id => this.id = +id)
    //  .subscribe(id => this.getReport());

    //this.getPeriods();
    this.getYears()
  }

  ngOnDestroy() {

  }

  ngAfterViewInit() {
    this.scroll.changes.subscribe((ellist: QueryList<any>) => {
      if (ellist.length > 0) {
        ellist.forEach((e, idx) => {
          if (!e.nativeElement['mcs']) {
            $(e.nativeElement).mCustomScrollbar("destroy");

            $(e.nativeElement).mCustomScrollbar({
              axis: "x",
              advanced: {
                updateOnContentResize: true
              },
              theme: "dark-thin",
              scrollButtons: {
                enable: true
              },
            });
          }
        });
      }

    });
  }


  showReport(event: Event) {
    this.getReport(this.selectedPeriod.id, this.selectedGroup.value);
  }

  nodeSelect(event) {

    if (event.node && event.node.children && event.node.children.length > 0) {
      if (event.node.expanded == false)
        event.node.expanded = true;
      else
        event.node.expanded = false;
    }
  }

  nodeUnselect(event) {

    if (event.node && event.node.children && event.node.children.length > 0) {
      event.node.expanded = false;
    }
  }
  periodChanged(event: Event) {
    this.selectedGroup = { value: "", text: '-' };
    this.groups = this.selectedPeriod.groups;
  }
  reportYearChanged(event: Event) {
    this.selectedGroup = { value: "", text: '-' };
    this.selectedPeriod = null;
    this.getPeriods();

  }
}



// WEBPACK FOOTER //
// ./src/app/dyn-reports/dyn-report/dyn-report10.component.ts